/**
 *
 * Sound
 *
 * https://github.com/pedrazzi/
 *
 * @version 0.0.1
 *
 */

class sound {
  constructor(o = {}) {
    const vm = this;
    vm.version = "0.0.1";
    vm.name = "sound";
    vm.audio = new Audio();
    // Setup user-defined default properties.
    vm.audio.autoplay = typeof o.autoplay === "boolean" ? o.autoplay : true;
    vm.audio.muted = typeof o.mute === "boolean" || false;
    vm.audio.loop = typeof o.loop === "boolean" || false;
    if (o.src) {
      vm.audio.src = typeof o.src !== "string" ? o.src : [o.src];
    }
    vm.audio.volume = o.volume !== undefined ? o.volume : 1;
    vm.audio.format = typeof o.format !== "string" ? o.format : [o.format];
    vm.audio.html5 = o.html5 || false;
    vm.audio.pool = o.pool || 5;
    vm.audio.preload = typeof o.preload === "boolean" ? o.preload : true;
    vm.audio.rate = o.rate || 1;
    vm.audio.sprite = o.sprite || {};
    vm.audio.xhrWithCredentials = o.xhrWithCredentials || false;
    // Setup all other default properties.
    //vm.audio.duration = 0;
    vm.audio.state = "unloaded";
    vm.audio.sounds = [];
    vm.audio.endTimers = {};
    vm.audio.queue = [];
    vm.audio.playLock = false;
    // Setup event listeners.
    vm.audio.onend = o.onend ? [{ fn: o.onend }] : [];
    vm.audio.onfade = o.onfade ? [{ fn: o.onfade }] : [];
    vm.audio.onload = o.onload ? [{ fn: o.onload }] : [];
    vm.audio.onloaderror = o.onloaderror ? [{ fn: o.onloaderror }] : [];
    vm.audio.onplayerror = o.onplayerror ? [{ fn: o.onplayerror }] : [];
    vm.audio.onpause = o.onpause ? [{ fn: o.onpause }] : [];
    vm.audio.onplay = o.onplay ? [{ fn: o.onplay }] : [];
    vm.audio.onstop = o.onstop ? [{ fn: o.onstop }] : [];
    vm.audio.onmute = o.onmute ? [{ fn: o.onmute }] : [];
    vm.audio.onvolume = o.onvolume ? [{ fn: o.onvolume }] : [];
    vm.audio.onrate = o.onrate ? [{ fn: o.onrate }] : [];
    vm.audio.onseek = o.onseek ? [{ fn: o.onseek }] : [];
    vm.audio.onunlock = o.onunlock ? [{ fn: o.onunlock }] : [];
    vm.audio.onresume = [];
  }

  play() {
    this.audio.play();
  }

  pause() {
    this.audio.paused ? this.play() : this.audio.pause();
  }

  stop() {
    this.audio.pause();
  }

  src() {
    const args = arguments;
    if (args.length === 0) {
      return this.audio.src;
    }
    const src = args[0];
    this.audio.src = typeof src !== "string" ? src : [src];
  }

  volume() {
    const args = arguments;
    if (args.length === 0) {
      return this.audio.volume;
    }
    this.audio.volume = args[0];
  }

  mute() {
    this.audio.muted = !this.audio.muted;
  }

  loop(value) {
    this.audio.loop = value;
  }

  duration() {
    return this.audio.duration;
  }

}
// TODO: CRIAR METODO Q RETORNA DADOS STATUS: DURAÇÃO / TYPO
export default sound;
